import { SortDirectionEnum, UserTicketsCollapsedSortColumnsEnum } from '../../..';

export class RequestUserTicketsCollapsedRequestDto {
  showUpcoming = true;
  showPast = true;
  sortDirection: SortDirectionEnum;
  sortColumn: UserTicketsCollapsedSortColumnsEnum;
}
